import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _renderSlot(_ctx.$slots, "item", {
      link: _ctx.item.link,
      title: _ctx.item.title
    }, undefined, true)
  ]))
}